import { gql } from "@apollo/client";

const GET_DOCUMENT_LIST = gql`
  query GET_DOCUMENT_LIST($hcpId: ObjectId, $hcfId: ObjectId, $shiftId: ObjectId) {
    documentList(hcpId: $hcpId, hcfId: $hcfId, shiftId: $shiftId) {
      _id
      name
      hcpId
      displayName
      issueDate
      expiry
      covidTest
      visible
      status
      state
      multiState
      subType
      createdAt
      uploadedFor {
        _id
        name
      }
      fulfilledRequirement {
        _id
        name
      }
      rejectionNotifiedAt
      notification {
        note
        pushNotification
        reason
      }
      requirement {
        expiryType
      }
    }
  }
`;

const DELETE_HCP_DOCUMENT = gql`
  mutation DELETE_HCP_DOCUMENT($_id: ObjectId!) {
    deleteHcpDocument(_id: $_id) {
      _id
      name
      displayName
      expiry
      visible
      status
      fulfilledRequirement {
        _id
        name
      }
    }
  }
`;

export { DELETE_HCP_DOCUMENT, GET_DOCUMENT_LIST };
